









































































































import _ from 'lodash'
import Vue from 'vue'
import Component from 'vue-class-component'
import {ConfigMap} from '@/modules/config'
import Login from '@/components/Login.vue'
import MachineSelect from '@/components/MachineSelect.vue'
import FileButton from '@/components/FileButton.vue'
import {AppConfigParameters, Document} from '@/store'
/**
 * Pantalla de configuración de la aplicación
 *
 * @author Alejandro G. Riaño <agutierrez@softcontrol.es>
 */
@Component({
    components: {FileButton, MachineSelect, Login}
})
export default class Config extends Vue {
    public newConfig: ConfigMap = {}

    public login = true
    public saveConfirm = false
    public resetConfirm = false
    public version = process.env.VUE_APP_VERSION

    /**
     * Guarda en la configuración el archivo informar al usuario sobre
     * la protección de datos
     *
     * @param files
     */
    public async saveDataProtectionDocument (files: FileList) {
        const pdf = files.item(0)
        if (!pdf) {
            return
        }

        this.newConfig.dataProtectionDocument = await Document.fromFile(pdf)
        this.$forceUpdate()
    }

    /**
     * Activa o desactiva la opción "validar formato DNI"
     */
    public set validateDNIFormat (value: boolean) {
        this.newConfig[AppConfigParameters.ValidateDNIFormat] = value
    }

    /**
     * Comprueba si la opción "validar formato del DNI" se encuentra activa
     */
    public get validateDNIFormat () {
        return this.newConfig[AppConfigParameters.ValidateDNIFormat] || false
    }

    public async save () {
        await this.$store.dispatch('saveAppConfig', this.newConfig)
        this.saveConfirm = false
    }

    public async reset () {
        await this.$store.dispatch('resetApp')
        await this.$router.push({name: 'setup'})
    }

    created () {
        this.newConfig = _.cloneDeep(this.$store.state.appConfig)
    }
}

